import wretch from 'wretch';
export function getSubscriptions(aid, token) {
  return wretch('/piano-api/user/access')
    .headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    })
    .post({
      aid,
      user_token: token,
    });
}
export function getWatchlist(memberDetail) {
  return wretch('/watchlist/get')
    .headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    })
    .post({ data: memberDetail })
    .json((data) => {
      return data;
    });
}
